import { render, staticRenderFns } from "./FormItemShareKeyword.vue?vue&type=template&id=72684ac6&scoped=true"
import script from "./FormItemShareKeyword.vue?vue&type=script&lang=js"
export * from "./FormItemShareKeyword.vue?vue&type=script&lang=js"
import style0 from "./FormItemShareKeyword.vue?vue&type=style&index=0&id=72684ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72684ac6",
  null
  
)

export default component.exports